module.exports = __webpack_public_path__ + "static/img/b15.955269e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/b15.png
// module id = 0p4D
// module chunks = 0